import styled from 'styled-components';

import { media } from '../../../core';
import Text from '../Text';

export interface LabelProps {
  htmlFor?: string;
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
}

const Label = styled(Text).attrs(({ theme, size }: LabelProps & { theme: any }) => ({
  as: 'label',
  size: size || 'small',
  weight: theme.fontWeight || 600,
}))<LabelProps>`
  display: block;
  margin: 0 0 6px;
  line-height: 1.5;

  ${media.tabletPortrait} {
    margin-bottom: 6px;
    font-weight: ${({ theme }) => theme.fontWeight || 600};
  }
`;

export default Label;
